import {
    ControlCalidadPermisos,
    ControlCalidadPerms,
    ControlCalidadRoutes,
    PermisosProceso,
} from '@core/utils/enums/controlCalidad'

export default [
    {
        path: '/operaciones/mantenimietno/estados',
        name: PermisosProceso.MANTENIMIENTO.VISUALIZAR_ESTADOS,
        component: () => import('@pages/controlCalidad/mantenimiento/simple/estados/MantenimientoEstadoWrapper.vue'),

        meta: {
            title: 'i18n:',
            pageTitle: 'Operaciones',
            action: PermisosProceso.MANTENIMIENTO.VISUALIZAR_ESTADOS,
            breadcrumb: [
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'Estados',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/operaciones/mantenimietno/permisos',
        name: PermisosProceso.MANTENIMIENTO.VISUALIZAR_PERMISOS,
        component: () =>
            import('@pages/controlCalidad/mantenimiento/compuesto/permisos/MantenimientoPermisosWrapper.vue'),
        meta: {
            title: 'i18n:',
            pageTitle: 'Operaciones',
            action: PermisosProceso.MANTENIMIENTO.VISUALIZAR_PERMISOS,
            breadcrumb: [
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'Permisos',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/operaciones/transacciones/procesos',
        name: ControlCalidadRoutes.TRANSACCION_PROCESOS,
        component: () => import('@pages/controlCalidad/transacciones/general/procesos/GenerarProcesosOperaciones.vue'),
        meta: {
            title: 'i18n:',
            pageTitle: 'Operaciones',
            action: PermisosProceso.GENERAL.TRANSACCIONES,
            breadcrumb: [
                {
                    text: 'Transacciones',
                },
                {
                    text: 'Procesos',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/operaciones/informes/procesos',
        name: ControlCalidadRoutes.INFORMES_PROCESOS,
        component: () => import('@pages/controlCalidad/informes/general/procesos/ConsultarProcesosOperaciones.vue'),
        meta: {
            title: 'i18n:',
            pageTitle: 'Operaciones',
            action: PermisosProceso.GENERAL.INFORMES,
            breadcrumb: [
                {
                    text: 'Informes',
                },
                {
                    text: 'Procesos',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/operaciones/informes/trazabilidad',
        name: ControlCalidadRoutes.TRAZABILIDAD_INFORME,
        component: () => import('@pages/controlCalidad/informes/general/procesos/ConsultarProcesosTrazabilidad.vue'),
        meta: {
            title: 'i18n:',
            pageTitle: 'Operaciones',
            action: ControlCalidadPermisos.CALIDAD.TRAZABILIDAD.VISUALIZAR,
            breadcrumb: [
                {
                    text: 'Informes',
                },
                {
                    text: 'Trazabilidad',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/operaciones/configuracion/correos',
        name: 'control-calidad-configurar-correos',
        component: () => import('@pages/controlCalidad/config/ConfigurarCorreos.vue'),
        meta: {
            title: 'i18n:',
            pageTitle: 'Embarque y Despacho',
            action: ControlCalidadPermisos.CONFIGURACION.DIFUSION_CORREOS.VISUALIZAR,
            breadcrumb: [
                { text: 'Configuracion' },
                {
                    text: 'Embarque y Despacho',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/operaciones/configuracion/firmas-contrasena',
        name: ControlCalidadRoutes.CONFIGURAR_FIRMA_CONTRASENA,
        component: () => import('@pages/controlCalidad/config/ConfigurarFirmasContrasena.vue'),
        meta: {
            title: 'i18n:',
            pageTitle: 'Cambio de Contraseña Firmas',
            action: ControlCalidadPermisos.CONFIGURACION.FIRMAS.CAMBIAR_PASSWORD,
            breadcrumb: [
                { text: 'Configuracion' },
                {
                    text: 'Cambio de Contraseña',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/operaciones/configuracion/firmas-usuarios',
        name: ControlCalidadRoutes.CONFIGURAR_FIRMAS_USUARIOS,
        component: () => import('@pages/controlCalidad/config/ConfigurarUsuariosCalidad.vue'),
        meta: {
            title: 'i18n:',
            pageTitle: 'Configuración de Usuarios',
            action: PermisosProceso.CONFIGURACION.USUARIOS.VISUALIZAR,
            breadcrumb: [
                { text: 'Configuracion' },
                {
                    text: 'Usuarios',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/operaciones/configuracion/configurar-poderes',
        name: ControlCalidadRoutes.CONFIGURAR_PODERES,
        component: () => import('@pages/controlCalidad/config/ConfigurarPoderes.vue'),
        meta: {
            title: 'i18n:',
            pageTitle: 'Configuración de Poderes',
            action: ControlCalidadPermisos.CONFIGURACION.PODERES.VISUALIZAR,
            breadcrumb: [
                { text: 'Configuracion' },
                {
                    text: 'Poderes',
                    active: true,
                },
            ],
        },
    },
    // Procesos
    {
        path: '/operaciones/configuracion/configurar-procesos',
        name: ControlCalidadRoutes.CONFIGURAR_PROCESOS,
        component: () => import('@pages/controlCalidad/procesos/ConfigurarProcesos.vue'),
        meta: {
            title: 'i18n:',
            pageTitle: 'Configuración de Procesos',
            action: ControlCalidadPermisos.CONFIGURACION.PROCESOS.VISUALIZAR,
            breadcrumb: [
                { text: 'Configuracion' },
                {
                    text: 'Listas',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/operaciones/informes/general',
        name: ControlCalidadRoutes.GENERAL,
        component: () => import('@pages/controlCalidad/informes/general/consultaInformes/ConsultaInformesGeneral.vue'),
        meta: {
            title: 'i18n:',
            pageTitle: 'Consulta de Informes',
            action: ControlCalidadPermisos.CALIDAD.INFORMES_GENERAL.VISUALIZAR,
            breadcrumb: [
                {
                    text: 'Consulta de Informes',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/operaciones/transacciones/general',
        name: ControlCalidadRoutes.GENERAL_TRANSACCION,
        component: () =>
            import(
                '@pages/controlCalidad/transacciones/general/consultaTransacciones/ConsultaTransaccionesGeneral.vue'
            ),
        meta: {
            title: 'i18n:',
            pageTitle: 'Transacciones',
            action: ControlCalidadPermisos.CALIDAD.TRANSACCIONES_GENERAL.VISUALIZAR,
            breadcrumb: [
                {
                    text: 'Transacciones',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/verificacion/informes/general',
        name: ControlCalidadRoutes.DOCUMENTAL_INFORMES_GENERAL,
        component: () => import('@pages/controlCalidad/informes/general/procesos/ConsultarProcesosVerificaciones.vue'),
        meta: {
            title: 'i18n:',
            pageTitle: 'Consulta de Informes',
            action: ControlCalidadPermisos.CALIDAD.INFORMES_GENERAL.VISUALIZAR,
            breadcrumb: [
                {
                    text: 'Consulta de Informes',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/verificacion/transacciones/general',
        name: ControlCalidadRoutes.DOCUMENTAL_TRANSACCIONES_GENERAL,
        component: () =>
            import('@pages/controlCalidad/transacciones/general/procesos/GenerarProcesosVerificaciones.vue'),
        meta: {
            title: 'i18n:',
            pageTitle: 'Transacciones',
            action: ControlCalidadPermisos.CALIDAD.TRANSACCIONES_GENERAL.VISUALIZAR,
            breadcrumb: [
                {
                    text: 'Transacciones',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/calidad/transacciones/general',
        name: ControlCalidadRoutes.DOCUMENTAL_TRANSACCIONES_GENERAL_FINAL,
        component: () => import('@pages/controlCalidad/transacciones/general/procesos/GenerarProcesosCalidad.vue'),
        meta: {
            title: 'i18n:',
            pageTitle: 'Transacciones',
            action: 'ver-control-calidad-documental-final',
            breadcrumb: [
                {
                    text: 'Transacciones',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/calidad/informes/general',
        name: ControlCalidadRoutes.DOCUMENTAL_INFORMES_GENERAL_FINAL,
        component: () => import('@pages/controlCalidad/informes/general/procesos/ConsultarProcesosCalidad.vue'),
        meta: {
            title: 'i18n:',
            pageTitle: 'Consulta de Informes',
            action: 'ver-control-calidad-documental-final',
            breadcrumb: [
                {
                    text: 'Consulta de Informes',
                    active: true,
                },
            ],
        },
    },
    // {
    //     path: '/operaciones/informes/trazabilidad',
    //     name: ControlCalidadRoutes.TRAZABILIDAD_INFORME,
    //     component: () => import('@pages/controlCalidad/informes/trazabilidad/Trazabilidad.vue'),
    //     meta: {
    //         title: 'i18n:',
    //         pageTitle: 'Trazabilidad',
    //         action: ControlCalidadPermisos.CALIDAD.TRAZABILIDAD.VISUALIZAR,
    //         breadcrumb: [
    //             { text: 'Informes' },
    //             {
    //                 text: 'Trazabilidad',
    //                 active: true,
    //             },
    //         ],
    //     },
    // },
    {
        path: '/operaciones/informes/acciones-correctivas',
        name: ControlCalidadRoutes.ACCIONES_CORRECTIVAS_INFORMES,
        component: () => import('@pages/controlCalidad/informes/accionesCorrectivas/AccionesCorrectivas.vue'),
        meta: {
            title: 'i18n:',
            pageTitle: 'Acciones Correctivas',
            action: ControlCalidadPermisos.CALIDAD.ACCIONES_CORRECTIVAS.INFORMES.VISUALIZAR,
            breadcrumb: [
                { text: 'Informes' },
                {
                    text: 'Acciones Correctivas',
                    active: true,
                },
            ],
        },
    },

    {
        path: '/operaciones/informes/acciones-correctivas-areas-asignadas',
        name: ControlCalidadRoutes.ACCIONES_CORRECTIVAS_AREAS_ASIGNADAS_INFORMES,
        component: () =>
            import('@pages/controlCalidad/informes/accionesCorrectivas/AccionesCorrectivasAreasAsignadas.vue'),
        meta: {
            title: 'i18n:',
            pageTitle: 'Acciones Correctivas',
            action: ControlCalidadPermisos.CALIDAD.ACCIONES_CORRECTIVAS_AREAS_ASIGNADAS.INFORMES.VISUALIZAR,
            breadcrumb: [
                { text: 'Informes' },
                {
                    text: 'Area',
                    active: true,
                },
            ],
        },
    },

    {
        path: '/operaciones/informes/acciones-correctivas-usuarios-asignados',
        name: ControlCalidadRoutes.ACCIONES_CORRECTIVAS_USUARIOS_ASIGNADOS_INFORMES,
        component: () =>
            import('@pages/controlCalidad/informes/accionesCorrectivas/AccionesCorrectivasUsuariosAsignados.vue'),
        meta: {
            title: 'i18n:',
            pageTitle: 'Acciones Correctivas',
            action: ControlCalidadPermisos.CALIDAD.ACCIONES_CORRECTIVAS_USUARIOS_ASIGNADOS.INFORMES.VISUALIZAR,
            breadcrumb: [
                { text: 'Informes' },
                {
                    text: 'Asignadas',
                    active: true,
                },
            ],
        },
    },

    {
        path: '/operaciones/configuracion/permisos',
        name: 'control-calidad-configuracion-permisos',
        component: () => import('@pages/controlCalidad/config/VerPermisos.vue'),
        meta: {
            title: 'i18n:',
            pageTitle: 'Ver Permisos',
            action: ControlCalidadPermisos.CONFIGURACION.PERMISOS.VISUALIZAR,
            breadcrumb: [
                { text: 'Configuracion' },
                {
                    text: 'Permisos',
                    active: true,
                },
            ],
        },
    },

    // No ocultar
    {
        // path: '/controlCalidad/transaccion/asignacion-responsable/:id_embarque?',
        path: '/operaciones/transaccion/asignacion-responsable/:id_embarque?',
        name: ControlCalidadRoutes.ASIGNACION_RESPONSABLE,
        component: () => import('@pages/controlCalidad/transacciones/GestionResponsables/AsignacionResponsables.vue'),
        meta: {
            title: 'i18n:pantallas.asignacion-responsables',
            pageTitle: 'Panel de Asignación',
            action: ControlCalidadPerms.VER_TRANSACCION_ASIGNACION_RESPONSABLE,
            breadcrumb: [
                {
                    text: 'Transacción',
                },
                {
                    text: 'Panel de Asignación',
                    active: true,
                },
            ],
        },
    },
    // No ocultar
    {
        // path: '/controlCalidad/transaccion/panelControlResponsable',
        path: '/operaciones/transaccion/panel-control-responsable',
        name: ControlCalidadRoutes.PANEL_CONTROL_RESPONSABLE,
        component: () => import('@pages/controlCalidad/transacciones/GestionResponsables/PanelControlResponsable.vue'),
        meta: {
            title: 'i18n:pantallas.panel-control-responsable',
            pageTitle: 'Gestión de Asignaciones',
            action: ControlCalidadPerms.VER_TRANSACCION_PANEL_CONTROL_RESPONSABLE,
            breadcrumb: [
                {
                    text: 'Transacción',
                },
                {
                    text: 'Gestión de Asignaciones',
                    active: true,
                },
            ],
        },
    },
    // No ocultar
    {
        // path: '/controlCalidad/transaccion/bandeja-control-asignaciones',
        path: '/operaciones/transaccion/bandeja-control-asignaciones',
        name: ControlCalidadRoutes.BANDEJA_CONTROL_ASIGNACIONES,
        component: () =>
            import('@pages/controlCalidad/transacciones/GestionResponsables/BandejaControlAsignaciones.vue'),
        meta: {
            title: 'i18n:pantallas.bandeja-control-asignaciones',
            pageTitle: 'Monitoreo de Asignaciones',
            action: ControlCalidadPerms.VER_TRANSACCION_BANDEJA_CONTROL_ASIGNACIONES,
            breadcrumb: [
                {
                    text: 'Transacción',
                },
                {
                    text: 'Monitoreo de Asignaciones',
                    active: true,
                },
            ],
        },
    },
    // No ocultar
    {
        // path: '/controlCalidad/transaccion/bandeja-embarque',
        path: '/operaciones/transaccion/bandeja-embarque',
        name: 'control-calidad-transaccion-bandeja-embarque',
        component: () => import('@pages/controlCalidad/transacciones/ReparticionLotes/BandejaEmbarques.vue'),
        meta: {
            title: 'i18n:',
            pageTitle: 'Bandeja de Embarques',
            action: 'ver-control-calidad-transaccion-bandeja-embarque',
            breadcrumb: [
                {
                    text: 'Bandeja de Embarques',
                    active: true,
                },
            ],
        },
    },

    // No ocultar
    {
        // path: '/controlCalidad/transaccion/asignacion-lote',
        path: '/operaciones/transaccion/asignacion-lote',
        name: 'control-calidad-transaccion-asignacion-lote',
        component: () => import('@pages/controlCalidad/transacciones/ReparticionLotes/AsignacionLotes.vue'),
        meta: {
            title: 'i18n:',
            pageTitle: 'Asignación de Lotes',
            action: 'ver-control-calidad-transaccion-asignacion-lote',
            breadcrumb: [
                {
                    text: 'Asignación de Lotes',
                    active: true,
                },
            ],
        },
    },
]
